import { withAppHOC } from "../../hoc";
import { StyledPageHeading, StyledPageBody } from "../../components/Styled";

const Disclaimers = () => {
  return (
    <>
      <StyledPageHeading>
        <h1>Disclaimers</h1>
      </StyledPageHeading>
      <StyledPageBody>
        <p>your disclaimers goes here</p>
      </StyledPageBody>
    </>
  );
};

export default withAppHOC(Disclaimers);
